import api from '../token';

export const AlterMoeda = async (dados) => {
  try {
    const response = await api.post('/alterMoeda', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};


